import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { useFaq } from "@/lib/faq/useFaq";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export default function Help() {
  const { t } = useTranslation("help");
  const { getCategoriesWithQuestions, search } = useFaq();
  const [query, setQuery] = useState("");

  const trimmed = query.trim();
  const results = trimmed ? search(trimmed) : null;
  const categories = getCategoriesWithQuestions();

  return (
    <div className="max-w-3xl mx-auto" data-testid="help-page">
      <h1 className="text-2xl font-semibold text-qenva-navy mb-6">{t("ui.panel_title")}</h1>

      <div className="relative mb-8">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={t("ui.search_placeholder")}
          data-testid="help-search-input"
          className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-qenva-blue/30"
        />
      </div>

      {results ? (
        results.length === 0 ? (
          <p className="text-sm text-zinc-500" data-testid="help-no-results">
            {t("ui.no_results", { query: trimmed })}
          </p>
        ) : (
          <ul className="space-y-4" data-testid="help-search-results">
            {results.map((r) => (
              <li key={r.id} className="border-b border-zinc-200 pb-4">
                <p className="font-medium text-qenva-navy mb-1">{r.q}</p>
                <p className="text-sm text-zinc-600">{r.a}</p>
              </li>
            ))}
          </ul>
        )
      ) : (
        <div data-testid="help-categories">
          {categories.map((category) => (
            <div key={category.id} className="mb-6">
              <h2 className="text-xs uppercase tracking-wider font-semibold text-zinc-500 mb-2">
                {category.title}
              </h2>
              <Accordion type="multiple">
                {category.questions.map((question) => (
                  <AccordionItem key={question.id} value={question.id}>
                    <AccordionTrigger data-testid={`help-question-${question.id}`}>
                      {question.q}
                    </AccordionTrigger>
                    <AccordionContent>{question.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
